export const ENV = {
  DEV: 'dev',
  TEST: 'test',
  RELEASE: 'prod',
};
export const WECHAT_APPID_MAP = new Map([
  // 福利鹅小程序
  ['benefit',  'gh_2090033ccf8e'],
]);

export const WECHAT_TYPE_MAP = new Map([
  [ENV.RELEASE, 0],
  // 实测对应的是开发版本，MSDK文档却为test
  [ENV.DEV, 1],
  [ENV.TEST, 2],
]);

// https://git.woa.com/obd/frontend-shared
export const MSDK_ADAPTER_URLS = {
  /** v3/v5 通用 */
  OFFICAL: 'https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js',
  LEGACY_V5: '//obd.gtimg.com/assets/js/msdkv5Helper.js',
  LEGACY_V3: '//obd.gtimg.com/assets/js/msdkJsAdapter.js',
};
